import React from 'react';
import { InfoCardData } from './types';
import InfoCard from './InfoCard';

interface InfoCardGridProps {
  cards: InfoCardData[];
}

const InfoCardGrid: React.FC<InfoCardGridProps> = ({ cards }) => (
  <div className="">
    {cards.map((card, idx) => (
      <InfoCard key={idx} {...card} />
    ))}
  </div>
);

export default InfoCardGrid;
